import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_RESEND_RELEASE_PAYMENT_HOLD_COL_DEF, transferRowData } from "presentation/constant/ResendReleasePaymentHold/ResendReleasePaymentHoldColumnDefinition";
import { INITIAL_RESEND_RELEASE_PAYMENT_HOLD_OICT_COL_DEF, INITIAL_RESEND_RELEASE_PAYMENT_HOLD_RSCT_COL_DEF } from "presentation/constant/ResendReleasePaymentHold/ResendReleasePaymentHoldColumnOictDefinition";
import { useResendReleasePaymentHoldVM } from "presentation/hook/ResendReleasePaymentHold/useResendReleasePaymentHoldVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useResendReleasePaymentHoldTracked } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import UpdateAgentDeliveryDatePanel from "./RightPanel/UpdateAgentDeliveryDatePanel";

const ResendReleasePaymentHoldTablePanel: React.FC = () => {
    const [resendReleasePaymentHoldState] = useResendReleasePaymentHoldTracked();
    const gridRef: any = useRef(null);
    const { resendReleasePaymentHoldList, isShowUpdatePanel } = resendReleasePaymentHoldState;
    const resendReleasePaymentHoldVM = useResendReleasePaymentHoldVM();
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(resendReleasePaymentHoldState.isSearchLoading || (
            !resendReleasePaymentHoldState.isSearchLoading &&
            resendReleasePaymentHoldState.resendReleasePaymentHoldList &&
            resendReleasePaymentHoldState.resendReleasePaymentHoldList.length) ? false : true);
    }, [resendReleasePaymentHoldState.isSearchLoading, resendReleasePaymentHoldState.resendReleasePaymentHoldList]);


    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        resendReleasePaymentHoldVM.updateSelectedRows(selectedRows);
    }, [resendReleasePaymentHoldVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='resend-release-payment-hold-table'
                isNewColumnSetting={true}
                columns={(operatingUnit === "SAPT" || operatingUnit === "KICT") ? INITIAL_RESEND_RELEASE_PAYMENT_HOLD_COL_DEF :
                    ((operatingUnit === "AQCT" || operatingUnit === "RSCT") ? INITIAL_RESEND_RELEASE_PAYMENT_HOLD_RSCT_COL_DEF : INITIAL_RESEND_RELEASE_PAYMENT_HOLD_OICT_COL_DEF)}
                data={transferRowData(resendReleasePaymentHoldList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                handleSelectionChanged={handleSelectionChange}
                isRowHighligted={true}
                rowSelection={"multiple"}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [handleSelectionChange, operatingUnit, resendReleasePaymentHoldList, showOverlay])

    return <>
        <div className={`main-comp-wrapper${isShowUpdatePanel ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={isShowUpdatePanel}
                leftSectionWidth={isShowUpdatePanel ? '80%' : '100%'}
                rightSectionWidth={isShowUpdatePanel ? '20%' : '0%'}
                draggable={true}
                leftChildren={memoTable}
                rightChildren={<UpdateAgentDeliveryDatePanel />} />
        </div>
    </>;
}

export default memo(ResendReleasePaymentHoldTablePanel);
